import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface AuthState {
    token: string | null;
    authenticated: boolean;
    error: string | null;
    isLoading: boolean;
    oauthProvider: 'google' | 'apple' | null;
    oauthLoading: boolean;
}

const initialState: AuthState = {
    token: null,
    authenticated: false,
    error: null,
    isLoading: false,
    oauthProvider: null,
    oauthLoading: false,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginUserSuccess(state, action: PayloadAction<string>) {
            state.token = action.payload;
            state.authenticated = true;
            state.error = null;
            state.isLoading = false;
            state.oauthLoading = false;
            state.oauthProvider = null;
        },
        loginUserError(state, action: PayloadAction<string>) {
            state.error = action.payload;
            state.authenticated = false;
            state.token = null;
            state.isLoading = false;
            state.oauthLoading = false;
            state.oauthProvider = null;
        },
        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload
        },
        setOAuthLoading(state, action: PayloadAction<{loading: boolean, provider?: 'google' | 'apple'}>) {
            state.oauthLoading = action.payload.loading;
            if (action.payload.provider) {
                state.oauthProvider = action.payload.provider;
            }
        },
        clearOAuthError(state) {
            state.error = null;
            state.oauthLoading = false;
            state.oauthProvider = null;
        },
        logoutUser(state) {
            state.token = null;
            state.authenticated = false;
            state.error = null;
            state.isLoading = false;
            state.oauthLoading = false;
            state.oauthProvider = null;
        }
    }
})

export const { loginUserSuccess, loginUserError, setIsLoading, setOAuthLoading, clearOAuthError, logoutUser } = authSlice.actions;

export default authSlice.reducer;

export type AuthAction =
  | ReturnType<typeof loginUserSuccess>
  | ReturnType<typeof loginUserError>
  | ReturnType<typeof setIsLoading>
  | ReturnType<typeof setOAuthLoading>
  | ReturnType<typeof clearOAuthError>
  | ReturnType<typeof logoutUser>;
